/**
 * FAQ Interfaces
 * Type definitions for FAQ management
 */

/**
 * FAQ translation from API
 */
export interface FaqTranslation {
  id: number;
  lang: string;
  lang_name: string;
  question: string;
  answer: string;
}

/**
 * FAQ record from API
 */
export interface FaqApiRecord {
  sequence: number;
  status: number;
  user_role_id: number | null;
  created_date?: string;
  updated_date?: string;
  translations: FaqTranslation[];
}

/**
 * User type / role option for FAQ form
 */
export interface FaqUserType {
  id: number;
  role_full_name: string;
  role_short_name: string;
}

/**
 * Flattened FAQ item for UI
 */
export interface FaqItem {
  id: number;
  question: string;
  answer: string;
  sequence: number;
  lang: string;
  lang_name: string;
  status?: number;
  user_role_id?: number | null;
}

/**
 * FAQ List Query Filters
 */
export interface FaqListFilters {
  lang?: string;
  user_role_id?: string | number;
}

/**
 * API Response for FAQ List
 */
export interface FaqListApiResponse {
  success?: boolean;
  status?: number;
  data: {
    faqs: FaqApiRecord[];
  };
}

/**
 * Language Item
 */
export interface LanguageItem {
  id: number;
  lang_name: string;
  short_name: string;
  status?: number;
}

/**
 * API Response for Language List
 */
export interface LanguageListApiResponse {
  data: LanguageItem[];
}

/**
 * FAQ Form Data (Create)
 */
export interface FaqCreatePayload {
  ques: string;
  ans: string;
  sequence: number;
  lang: string;
  user_role_id: number;
}

/**
 * FAQ Form Data (Update)
 */
export interface FaqUpdatePayload extends FaqCreatePayload {
  id: number;
}

/**
 * FAQ Toggle Status Payload
 */
export interface FaqToggleStatusPayload {
  id: number;
  active_status: 0 | 1;
}

/**
 * API Response for Create/Update FAQ
 */
export interface FaqMutationApiResponse {
  body?: {
    data: {
      message: string;
    };
  };
  data?: {
    message?: string;
  };
  message?: string;
  success?: boolean;
}
